<div>
  <button *ngIf="!(isAuthorised$ | async)" class="ui link button" (click)="signIn()">
    {{ 'txt_navigation_header_sign_in' | translate }}
  </button>
  <button *ngIf="isAuthorised$ | async" class="ui link button" (click)="signOut()">
    {{ 'txt_navigation_header_sign_out' | translate }}
  </button>
</div>
